import { Box, makeStyles, Theme, Typography } from '@material-ui/core';
import MobileOffIcon from '@material-ui/icons/MobileOff';
import { WbButton } from '../WbButton';

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: 'auto',
      padding: theme.spacing(4),
      textAlign: 'center',
      gap: theme.spacing(3),
    },
    iconWrapper: {
      width: 120,
      height: 120,
      borderRadius: '50%',
      border: `2px dashed ${theme.palette.grey[300]}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    icon: {
      fontSize: 60,
      color: theme.palette.primary.light,
    },
    title: {
      fontWeight: 700,
      fontSize: '1.4rem',
    },
    description: {
      color: theme.palette.text.secondary,
      maxWidth: 320,
    },
    primaryAction: {
      width: '100%',
      maxWidth: 320,
    },
  }),
  { name: 'WbMobileGraphFallback' },
);

export type MobileGraphFallbackAction = {
  label: string;
  onClick: () => void;
};

export type WbMobileGraphFallbackProps = {
  title: string;
  description: string;
  primaryAction?: MobileGraphFallbackAction;
  secondaryAction?: MobileGraphFallbackAction;
};

export const WbMobileGraphFallback = ({
  title,
  description,
  primaryAction,
  secondaryAction,
}: WbMobileGraphFallbackProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.iconWrapper}>
        <MobileOffIcon className={classes.icon} />
      </Box>

      <Typography variant="h5" className={classes.title}>
        {title}
      </Typography>

      <Typography variant="body2" className={classes.description}>
        {description}
      </Typography>

      {primaryAction && (
        <WbButton
          label={primaryAction.label}
          variant="contained"
          color="primary"
          size="large"
          className={classes.primaryAction}
          onClick={primaryAction.onClick}
        />
      )}

      {secondaryAction && (
        <WbButton
          label={secondaryAction.label}
          variant="text"
          color="primary"
          size="small"
          onClick={secondaryAction.onClick}
        />
      )}
    </Box>
  );
};
